import JumboClient from '@grofers/jumbo-client-js/dist/jumbo';
import { datadogRum } from '@datadog/browser-rum';
import { stripPiiFromEventPayload } from '../../dev-tools/datadog/piiScrubber';
import {
  EventFeatureMap,
  EventType,
  LIFELINE_TABLE_NAME,
  MetricsForJumboEvent,
} from './constants';
import { parseJwt, cookieToken } from '../utils/CookieToken';
import { v4 as uuidv4 } from 'uuid';
import { getGlobalTraits } from './events';

let jumboClient = null;

if (typeof window !== 'undefined') {
  jumboClient = JumboClient.getInstance();
}

export const setJumboHeaders = () => {
  let decodedToken = {};
  try {
    decodedToken = cookieToken ? parseJwt(cookieToken) : {};
  } catch (e) {
    decodedToken = {};
  }
  jumboClient.setParams({
    url: 'https://jumbo.blinkit.com/event',
    source: 'web',
    session_id: uuidv4(),
    user_id: decodedToken?.external_user_id,
  });
};

const getValueInString = (value) => {
  if (!value) return '';
  return value.toString();
};

const strigyfyEventDataValues = (eventValue) => {
  let updatedEventValue = {};

  const dataKeys = Object.keys(eventValue);

  for (let i = 0; i < dataKeys.length; i++) {
    const key = dataKeys[i];
    if (key === MetricsForJumboEvent.feature_meta) {
      const feature_meta_keys = Object.keys(eventValue[key]);
      let strifiedFeatureMeta = {};
      for (let j = 0; j < feature_meta_keys.length; j++) {
        strifiedFeatureMeta[feature_meta_keys[j]] = getValueInString(
          eventValue[key][feature_meta_keys[j]],
        );
      }
      updatedEventValue[MetricsForJumboEvent.feature_meta] =
        strifiedFeatureMeta;
    } else updatedEventValue[key] = getValueInString(eventValue[key]);
  }

  return updatedEventValue;
};

/* 
  Steps to add new jumbo event-
    1. get new event added in https://github.com/Zomato/jumbo-event-registry 
    2. add event details in './constants' and event function in './events.js'
    3. call above event func (point 2) where you want to trigger the event.
*/

export const sendEventToJumbo = async ({
  eventName,
  eventProperties,
  traits,
}) => {
  if (process.env.NODE_ENV !== 'production' || !eventName) return;
  let eventValue = {
    event_name: eventName,
    ...eventProperties,
    ...traits,
  };

  const jumboMetricIds = {
    [MetricsForJumboEvent.customer_id]: getValueInString(
      eventValue[MetricsForJumboEvent.customer_id],
    ),
    [MetricsForJumboEvent.order_id]: getValueInString(
      eventValue[MetricsForJumboEvent.order_id],
    ),
    [MetricsForJumboEvent.cart_id]: getValueInString(
      eventValue[MetricsForJumboEvent.cart_id],
    ),
  };

  eventValue = { ...eventValue, ...jumboMetricIds };

  const strigifiedEventValues = strigyfyEventDataValues(eventValue);

  if (!jumboClient) {
    return;
  }

  jumboClient.sendToJumbo(LIFELINE_TABLE_NAME, strigifiedEventValues);
  jumboClient.sendEventsToJumbo();

  if (datadogRum.getInitConfiguration()) {
    const ddSafePayload = stripPiiFromEventPayload(strigifiedEventValues);
    datadogRum.addAction(eventName, {
      ...ddSafePayload,
      source: 'jumbo_bridge',
    });
  }
};

export const createAndSendEvent = (
  eventName,
  properties = {},
  eventType = EventType.CLICK,
) => {
  const traits = getGlobalTraits();

  const eventProperties = {
    ...properties,
    event_type: eventType,
    feature_name: EventFeatureMap[eventName],
  };

  sendEventToJumbo({
    eventName,
    eventProperties,
    traits,
  });
};
